<template>
  <div>
    <template v-if="successStatus">
      <div class="message-box">
        <div class="msg-item">
          <img class="hint-img" src="@/assets/svg/完成.svg" alt="" />
        </div>
        <div class="msg-item"><span class="msg">注册成功，已自动登录</span></div>
        <div class="login-btn__wrapper clearfix">
          <button class="login-btn login-btn_big active-login" @click="customLogin">
            我知道了
          </button>
        </div>
      </div>
    </template>
    <template v-if="!successStatus">
      <div :class="['login-box__wrapper', tel_error ? 'err-focus' : '']">
        <input
          @focus="getFocus"
          @blur="removeFocus"
          type="text"
          id="tell1"
          class="login-input login-input_big"
          placeholder="请输入手机号"
          v-model="tel"
        />
        <span class="hint errright">{{ tel_error }}</span>
      </div>
      <div :class="['login-box__wrapper', 'clearfix', code_error ? 'err-focus' : '']">
        <input
          v-model="code"
          @focus="getFocus"
          @blur="removeFocus"
          type="text"
          class="login-input login-input_big login-input_left login-input_psw fl"
          placeholder="验证码"
        />
        <span class="hint errcenter">{{ code_error }} </span>
        <countBtn
          @result="resultHandler"
          :usage="resUse"
          class="modal-count"
          :value="tel"
          :clean="clean"
        ></countBtn>
      </div>
      <div :class="['login-box__wrapper', 'clearfix', password_error ? 'err-focus' : '']">
        <input
          id="psw"
          @focus="getFocus"
          @blur="removeFocus"
          v-model="psw"
          :type="show ? 'text' : 'password'"
          class="login-input login-input_big fl"
          placeholder="输入密码(6-20位数字和字母组合)"
        />
        <div :class="['login-svg', show ? 'show' : '']" alt="" @click="changeEye"></div>
      </div>
      <div class="login-box__handle clearfix right">
        <span class="hint errleft">{{ password_error }}</span>
        <a-checkbox @change="checked = !checked" :checked="checked"
          >我同意<a style="color:#1890ff;" target="_blank" href="/search/agree"
            >用户协议</a
          ></a-checkbox
        >
      </div>
      <div class="login-btn__wrapper clearfix">
        <a-button
          :disabled="!validBind"
          :class="['login-btn', 'login-btn_big', validBind ? 'active-login' : 'disable']"
          :loading="loading"
          @click="enroll"
          >注册并登录</a-button
        >
      </div>
      <div class="login-box__handle center">
        <span><a class="handle" href="javascript:void(0)" @click="toLogin">已有账号去登录</a></span>
      </div>
    </template>
  </div>
</template>
<script>
import sha256 from 'js-sha256'
import { loadFromLocal, saveToLocal } from '@/utils/local'
import { api_post } from '@/utils/http.ts'
import { msgTip } from '@/utils/urlUtils'
import enrollMixin from './enrollMixin.js'
export default {
  mixins: [enrollMixin],
  data() {
    return {
      checked: false,
      successStatus: false,
      coupon: '',
      resUse: { usage: 'register' },
      loading: false
    }
  },
  methods: {
    toLogin() {
      this.clearEnroll()
      this.$emit('go_login')
    },
    showSuccessMsg(data) {
      this.successStatus = true
      //hide header
      this.hideHeader(true)
      let that = this
      setTimeout(() => {
        that.customLogin()
        that.successStatus = false
        that.hideHeader(false)
        that.loginSuccessHandler(data)
      }, 2000)
    },
    loginSuccessHandler(data) {
      //todo 处理登录，注册成功后的全局信息
      if (data) {
        saveToLocal('net_username', data.username)
        this.$store.commit('SET_USER', { name: data.username })
        this.$store.commit('SET_USER_INFO', data)
        this.$emit('login_success', this.coupon)
        this.$sa.login(data.phone)
        // window.location.href = '/search/'
      } else {
        msgTip({
          type: 'error',
          msg: 'error'
        })
      }
    },
    async enroll() {
      let params = {
        username: this.tel,
        code: this.code,
        // password: sha256(this.psw)
        password: this.psw
      }
      this.loading = true
      if (this.token) {
        params.token = this.token
      }
      let rdata = await api_post('/search/api/auth/register', params)
      if (rdata.success) {
        setTimeout(() => {
          this.$sa.track('ContentRepository_Register', {
            buttonName: '注册并登录',
            success: true
          })
        }, 50)
        if (rdata.data) {
          this.coupon = rdata.data.coupon
          this.showSuccessMsg(rdata.data)
        }
      } else {
        this.showError(rdata)
        setTimeout(() => {
          this.$sa.track('ContentRepository_Register', {
            buttonName: '注册并登录',
            success: false
          })
        }, 50)
      }
      this.loading = false
    },
    hideHeader(flag) {
      let header = document.querySelector('.modal-header')
      let title = document.querySelector('.modal-title')

      if (flag) {
        if (header && title) {
          header.style.display = 'none'
          title.style.display = 'none'
        }
      } else {
        if (header && title) {
          header.style.display = 'block'
          title.style.display = 'block'
        }
      }
    },
    customLogin() {
      this.$emit('on_cancel')
      this.successStatus = false
      this.hideHeader(false)
    }
  },
  computed: {
    validBind: function() {
      return this.tel && this.code && this.psw && this.checked
    },
    token() {
      return this.$route.query.token || ''
    }
  },
  watch: {
    clean: function(val) {
      if (val) {
        this.clearEnroll()
      }
    }
  }
}
</script>
<style lang="scss" scoped>
.hint.errcenter {
  right: 105px;
}
.message-box {
  text-align: center;
  .hint-img {
    height: 99px;
    width: 99px;
  }
  .msg-item {
    padding: 10px 0px;
    .msg {
      width: 160px;
      height: 24px;
      font-size: 16px;
      font-family: PingFangSC-Medium;
      font-weight: 500;
      color: rgba(0, 0, 0, 1);
      line-height: 24px;
    }
  }
}
</style>
